import React, {useEffect, useRef} from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import PropTypes from "prop-types";
import styled from 'styled-components'


const Root = styled.div`
  height: 700px;
`

ChartJS.register(
  CategoryScale,
  ChartDataLabels,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function HourPriceLineGraph({ options, data, quality, plugins }) {
  const chartRef = useRef(null);
  useEffect(() => {
    const chart = chartRef.current;
    window.addEventListener('resize', () => {
      if (window.innerWidth < 1400) {
        chart.config.options.plugins.legend.labels.font.size = 16;
        chart.config.options.plugins.legend.position= 'bottom';
        chart.config.options.plugins.legend.align= 'start';
      } else {
        chart.config.options.plugins.legend.labels.font.size = 16;
        chart.config.options.plugins.legend.position= 'right';
        chart.config.options.plugins.legend.align= 'center';
      }
    });
  }, []);
  return (
    <div className="container">
      <div className='row justify-content-between'>
        <div>
          <div className='col-2 justify-content-start' >
            <p className='body3' style={{ color: '#2A2E33' }}>Pris (kr/m3fub)</p>
          </div>
          <Root className='col-12'>
            <Line
             ref={chartRef}
              data={data}
              options={options}
              plugins={plugins}
              quality={quality} />
          </Root>
        </div>
      </div>
    </div>
  )
}

HourPriceLineGraph.propTypes = {
  data: PropTypes.shape({}),
  quality: PropTypes.number,
  options: PropTypes.shape({}),
  plugins: PropTypes.arrayOf({}),
};

HourPriceLineGraph.defaultProps = {
  data: undefined,
  quality: undefined,
  options: undefined,
  plugins: undefined,
}

export default HourPriceLineGraph;